<template>
  <div class="tests is-margin-top">

    <section>
      <div id='#test_container' class='container'>

        <div class="columns is-margin-top">
          <div class="column is-half"> 
            <nav class="breadcrumb" aria-label="breadcrumbs">
              <ul>
                <li class="is-active"><button id='refresh_button' class="button" @click='fetch_data()'><b-icon icon="refresh"></b-icon></button><a href="#/tests" aria-current="page">Тесты</a></li>
              </ul>
            </nav>

            <div>
              <b-table :data="data_tests" :selected.sync="selected_test" paginated :loading='data_loading'>
                <template slot-scope="props">
                  <b-table-column label="Наименование теста" field='name' sortable>
                    {{ props.row.name }}
                  </b-table-column>
                  <b-table-column label="Кол-во вопросов" field='length' numeric sortable>
                    {{ props.row.length }}
                  </b-table-column>
                  <b-table-column label="Дата изменения" field='changed' sortable>
                    {{ new Date(props.row.changed).toLocaleString() }}
                  </b-table-column>
                  <b-table-column label="Сложность" field='level' numeric>
                    {{ props.row.level }}
                  </b-table-column>
                  <b-table-column field='active' label="Активен">
                    <b-checkbox disabled v-model='props.row.active'></b-checkbox>
                  </b-table-column>
                </template>
              </b-table>
            </div>
          </div>
          <div class='column is-half'>
            <section class='is-margin-top'>
              <button class='button' @click='add_test_button_click()'>+ Добавить тест</button>
            </section>
            <section class='is-margin-top box fast_edit'>
              <b-tabs class="block" v-if='selected_test.hasOwnProperty("name")' :animated='false'>
                <b-tab-item label="Основные">
                  <div>
                    <b-field label="Наименование теста" class='is-margin-top'>
                      <b-input placeholder='Наименование теста' v-model='selected_test.name'></b-input>
                    </b-field>
                    <b-field label="Кол-во вопросов">
                      {{ selected_test.length }}
                    </b-field>
                    <b-field label="Дата изменения">
                      {{ new Date(selected_test.changed).toLocaleString() }}
                    </b-field>
                    <b-field label="Сложность">
                      <b-input placeholder='Сложность' v-model='selected_test.level' type='number' min='0' max='5'></b-input>
                    </b-field>
                    <b-field label="Привязка к комнатам (через запятую)">
                      <b-input placeholder='Комната' v-model='selected_test.room'></b-input>
                    </b-field>
                    <b-field label="Активен">
                      <b-switch v-model="selected_test.active"></b-switch>
                    </b-field>

                    <b-field >
                      <media-uploader label='При открытии' v-model='selected_test.on_open'>
                      </media-uploader>
                    </b-field>
                    <b-field >
                      <media-uploader label='Результат (верно)' v-model='selected_test.on_pass'>
                      </media-uploader>
                    </b-field>
                    <b-field>
                      <media-uploader label='Результат (неверно)' v-model='selected_test.on_fail'>
                      </media-uploader>
                    </b-field>

                    <!-- <button class='button'>Редактировать вопросы</button> -->
                    
                  </div>
                </b-tab-item>

                <b-tab-item label="Описание">

                  <media-uploader class='is-margin-top' label='Картинка для меню [200x200]' :files='["image"]' v-model='selected_test.image'></media-uploader>

                  <b-field label="Краткое описание">
                    <b-input maxlength="200" type="textarea" v-model='selected_test.description'></b-input>
                  </b-field>
                </b-tab-item>

                <b-tab-item label="Параметры">

                  <b-field label="Цена участия">
                    <b-input type="number" v-model='selected_test.price'></b-input>
                  </b-field>

                  <b-field label="Приз за участие">
                    <b-input type="number" v-model='selected_test.prize'></b-input>
                  </b-field>

                </b-tab-item>

                <b-tab-item label="Вопросы">
                  <div>
                    <div class="field has-addons">
                      <div class="control">
                        <button class='button' @click='prev_question'> &larr; </button>
                      </div>
                      <div class="control">
                        <b-input style='width: 45px' v-model='question_id'></b-input>
                      </div>
                      <div class="control">
                        <button class='button' @click='is_question_search = true'> поиск </button>
                      </div>
                      <div class="control">
                        <button class='button' @click='next_question'> &rarr; </button>
                      </div>
                    </div>
                  </div>
                  <div class='is-margin-top box' v-if='current_question !== null'>
                    <b-field>
                      <button class="delete is-pulled-right" @click='delete_question(current_question)'></button>
                    </b-field>
                    <b-tabs position="is-right" class="block" v-if='selected_test.hasOwnProperty("name")' :animated='false'>
                      <b-tab-item label='Текст'>
                        <b-field class='is-margin-top'>
                          <b-input placeholder="Вопрос" maxlength="200" type="textarea" v-model='current_question.text'></b-input>
                        </b-field>
                        <b-field label='Правильный ответ'>
                          <b-field>
                            <b-radio-button v-model="current_question.right_answer" :native-value='1'>1</b-radio-button>
                            <b-radio-button v-model="current_question.right_answer" :native-value='2'>2</b-radio-button>
                            <b-radio-button v-model="current_question.right_answer" :native-value='3'>3</b-radio-button>
                            <b-radio-button v-model="current_question.right_answer" :native-value='4'>4</b-radio-button>
                          </b-field>
                        </b-field>
                        <b-field>
                          <b-input placeholder='Ответ 1' type='text' v-model='current_question.answer1_text'></b-input>
                        </b-field>
                        <b-field>
                          <b-input placeholder='Ответ 2' type='text' v-model='current_question.answer2_text'></b-input>
                        </b-field>
                        <b-field>
                          <b-input placeholder='Ответ 3' type='text' v-model='current_question.answer3_text'></b-input>
                        </b-field>
                        <b-field>
                          <b-input placeholder='Ответ 4' type='text' v-model='current_question.answer4_text'></b-input>
                        </b-field>
                      </b-tab-item>
                      <b-tab-item label='Медиа'>
                        <media-uploader class='is-margin-top' label='Вопрос' v-model='current_question.on_open'></media-uploader>

                        <media-uploader class='is-margin-top' label='Аудио - Ответ 1' :files='["audio"]' v-model='current_question.answer1_media'></media-uploader>
                        <media-uploader class='is-margin-top' label='Аудио - Ответ 2' :files='["audio"]' v-model='current_question.answer2_media'></media-uploader>
                        <media-uploader class='is-margin-top' label='Аудио - Ответ 3' :files='["audio"]' v-model='current_question.answer3_media'></media-uploader>
                        <media-uploader class='is-margin-top' label='Аудио - Ответ 4' :files='["audio"]' v-model='current_question.answer4_media'></media-uploader>

                        <media-uploader class='is-margin-top' label='Результат (верно)' v-model='current_question.on_pass'></media-uploader>
                        <media-uploader class='is-margin-top' label='Результат (неверно)' v-model='current_question.on_fail'></media-uploader>
                      </b-tab-item> 
                    </b-tabs>

                  </div>
                  <div v-else class='notification is-margin-top'>
                    Вопроса под таким номером не существует.
                  </div>
                  <button class='button' @click='add_question_to_selected_test()'>+ Добавить вопрос</button>
                </b-tab-item>
                <button class='button is-primary is-margin-top' @click='save_selected_test()'>Сохранить</button>
              </b-tabs>
              <div v-else class='is-margin-top notification'>
                Выберите тест для быстрого редактирования.
              </div>
            </section>
          </div>

          <b-modal :active.sync="is_asking_for_test_name" :width="640" scroll="keep">
            <div class="card">
              <header class="card-header">
                <p class="card-header-title">
                  Создать новый тест
                </p>
              </header>
              <div class="card-content">
                <b-field label='Название теста'>
                  <b-input placeholder='Название теста' type='text' v-model='new_test_name'></b-input>
                </b-field>
              </div>
              <footer class="card-footer">
                <a class="card-footer-item" @click='close_new_test_modal()'>Отмена</a>
                <a class="card-footer-item" @click='create_test()'>Создать</a>
              </footer>
            </div>
          </b-modal>

        </div>
      
      </div>

      <b-modal :active.sync="is_question_search">
        <div class='card'>
          <div class="card-content">
            <b-table :data='questions_table' :bordered='true' :stripped='true' :paginated='true' :per-page='10'>
               <template slot-scope="props">
                <b-table-column field="id" label="ID" width="40" numeric>
                    {{ props.row.id }}
                </b-table-column>
                <b-table-column field="name" label="name">
                    <a @click='select_question_id(props.row.id)'>{{ props.row.name }}</a>
                </b-table-column>
               </template>
            </b-table>
          </div>
        </div>
      </b-modal>

    </section>

  </div>
</template>

<script>
  export default {
    name: 'Tests',
    data () {
      this.$parent.active_tab = 'tests'
      this.fetch_data()
      return {
        activeTab: 0,
        question_id: 1,
        data_loading: true,
        data_tests: [],
        selected_test: {},
        new_test_name: '',
        is_question_search: false,
        is_asking_for_test_name: false,
        new_test: {'name': '', 'length': 0, 'changed': '', 'level': 0, 'active': false},
        empty_question: {
          text: '',
          on_open: {audio: {name: '', filename: '', filetype: '', filesize: 0}, image: {name: '', filename: '', filetype: '', filesize: 0}, video: {name: '', filename: '', filetype: '', filesize: 0}},
          on_pass: {audio: {name: '', filename: '', filetype: '', filesize: 0}, image: {name: '', filename: '', filetype: '', filesize: 0}, video: {name: '', filename: '', filetype: '', filesize: 0}},
          on_fail: {audio: {name: '', filename: '', filetype: '', filesize: 0}, image: {name: '', filename: '', filetype: '', filesize: 0}, video: {name: '', filename: '', filetype: '', filesize: 0}},
          answer1_text: '',
          answer1_media: {audio: {name: '', filename: '', filetype: '', filesize: 0}, image: {name: '', filename: '', filetype: '', filesize: 0}, video: {name: '', filename: '', filetype: '', filesize: 0}},
          answer2_text: '',
          answer2_media: {audio: {name: '', filename: '', filetype: '', filesize: 0}, image: {name: '', filename: '', filetype: '', filesize: 0}, video: {name: '', filename: '', filetype: '', filesize: 0}},
          answer3_text: '',
          answer3_media: {audio: {name: '', filename: '', filetype: '', filesize: 0}, image: {name: '', filename: '', filetype: '', filesize: 0}, video: {name: '', filename: '', filetype: '', filesize: 0}},
          answer4_text: '',
          answer4_media: {audio: {name: '', filename: '', filetype: '', filesize: 0}, image: {name: '', filename: '', filetype: '', filesize: 0}, video: {name: '', filename: '', filetype: '', filesize: 0}},
          right_answer: 1
        }
      }
    },
    methods: {
      fetch_data: function () {
        var t = this
        t.data_loading = true
        var form = JSON.stringify({method: 'admin_get_tests', params: {}})
        window.$.post(window.gw + 'api/game', {data: form}, function (r) {
          var d = JSON.parse(r)
          if (d.result === 'ok') {
            t.data_tests = d.params.tests
            t.data_loading = false
            t.data_tests.forEach(function (test) {
              if (test.questions === undefined) test.questions = []
            })
          }
        })
        return
      },
      add_test_button_click: function () {
        // this.$dialog.alert('Everything looks fine!')
        // this.$dialog.prompt({
        //   message: 'Введите название теста',
        //   inputAttrs: {
        //     placeholder: 'Название теста',
        //     maxlength: 255
        //   },
        //   onConfirm: (value) => this.add_test(value)
        // })
        // this.add_test('Новый тест')
        this.is_asking_for_test_name = true
      },
      create_test: function () {
        if (this.new_test_name !== '') this.add_test(this.new_test_name)
        this.new_test_name = ''
        this.is_asking_for_test_name = false
      },
      add_test: function (name) {
        var t = this
        t.data_loading = true
        var form = JSON.stringify({method: 'admin_add_test', params: {'testname': name}})
        window.$.post(window.gw + 'api/game', {data: form}, function (r) {
          var d = JSON.parse(r)
          if (d.result === 'ok') {
            t.fetch_data()
            t.$toast.open('Готово!')
          }
        })
        return
      },
      close_new_test_modal: function () {
        this.is_asking_for_test_name = false
        this.new_test_name = ''
      },
      save_selected_test: function () {
        var t = this
        t.data_loading = true
        var form = JSON.stringify({method: 'admin_save_test', params: {'test': t.selected_test}})
        window.$.post(window.gw + 'api/game', {data: form}, function (r) {
          var d = JSON.parse(r)
          if (d.result === 'ok') {
            // t.fetch_data()
            t.$toast.open('Готово!')
          }
          t.data_loading = false
        })
        return
      },
      add_question_to_selected_test: function () {
        // this.selected_test.questions.push(Object.assign({}, this.empty_question))
        this.selected_test.questions.push(JSON.parse(JSON.stringify(this.empty_question)))
        this.question_id = this.selected_test.questions.length
      },
      delete_question: function (question) {
        this.selected_test.questions.splice(this.selected_test.questions.indexOf(question), 1)
        this.prev_question()
      },
      next_question: function () {
        if ((this.question_id + 1) > this.selected_test.questions.length) return
        this.question_id++
      },
      prev_question: function () {
        if ((this.question_id - 1) === 0) return
        this.question_id--
      },
      select_question_id: function (id) {
        this.question_id = id
        this.is_question_search = false
      }
    },
    computed: {
      current_question: function () {
        if (this.selected_test === {}) return null
        if (this.selected_test.questions === undefined) return null
        if (this.question_id < 1) return null
        if (this.question_id > (this.selected_test.questions.length)) return null
        return this.selected_test.questions[this.question_id - 1]
      },
      questions_table: function () {
        var t = []
        if (this.selected_test === {}) return t
        if (this.selected_test === undefined) return t
        if (this.selected_test.questions === undefined) return t
        this.selected_test.questions.forEach(function (test, i) {
          console.log(test, i)
          t.push({id: ++i, name: test.text})
        })
        return t
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #test_container {
    padding: 16px;
  }
  #refresh_button {
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Tests.vue